function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgTwitchIcon = function SvgTwitchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18282_116294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.6375 26.8362L40.5323 34.7295L32.533 34.6236L25.4409 41.5303L25.5336 34.5309L16.5344 34.4117L16.9316 4.41431L48.9288 4.83807L48.6375 26.8362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9855 0.388287L4.8539 10.255L4.37716 46.2518L16.3761 46.4107L16.2437 56.4099L26.3752 46.5432L34.3745 46.6491L52.6113 28.8891L52.9821 0.89151L14.9855 0.388287ZM48.6382 26.8363L40.5329 34.7296L32.5336 34.6237L25.4415 41.5304L25.5342 34.531L16.535 34.4118L16.9323 4.41442L48.9295 4.83819L48.6382 26.8363Z",
    fill: "#9146FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8375 11.758L38.8379 11.7051L38.679 23.704L42.6786 23.757L42.8375 11.758Z",
    fill: "#9146FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8375 11.6125L27.8379 11.5596L27.679 23.5585L31.6786 23.6115L31.8375 11.6125Z",
    fill: "#9146FF"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18282_116294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.984375 0.202881) rotate(0.758774)"
  }))));
};
export default SvgTwitchIcon;